import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useAxios } from '../context/AxiosContext';

export function useOrgsList({ search }: { search: string | undefined }) {
  const { authAxios } = useAxios();

  const fetchOrgs = useCallback(
    async ({ searchTerm = undefined }) => {
      const response = await authAxios.get('/role/context/search', {
        params: { term: searchTerm }
      });

      return response.data;
    },
    [authAxios]
  );

  return useQuery(['organizationsList', search], () => fetchOrgs({ searchTerm: search }), {
    refetchOnWindowFocus: false,
    suspense: false
  });
}
